import React, { useCallback, useEffect, useState } from 'react';
import { Modal, Table, Col, Container, Form, FormGroup, Label, ModalBody, Row, UncontrolledTooltip } from 'reactstrap';
import { AddUserButton, CommonButton, SearchInput, SingleSelect, UserInput, UserTextArea } from '../../../Components/CommonComponents';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { getHolidayList, addHoliday, updateHoliday, deleteHoliday } from '../../../constants/apiCalls';
import closeImg from '../../../images/modalclose.png'
import editIcon from '../../../images/editIcon.png'
import deleteIcon from '../../../images/Delete.png'
import swal from 'sweetalert';
import ModalService from '../../../services/ModalService';
import './index.css'
import { DashBoardTitle } from '../../../Components/Title';
import { messages } from '../../../utils/constant-messages';
import { Permissions } from '../../../constants/Permissions';
import { useNavigate } from 'react-router-dom';
import lodash from 'lodash';
import DateService from '../../../services/DateService';
import { handleErrorMessage } from '../../../utils/utils';
import { useSelector } from 'react-redux';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const monthArr = [{ id: 1, monthName: 'January' }, { id: 2, monthName: 'February' }, { id: 3, monthName: 'March' }, { id: 4, monthName: 'April' }, { id: 5, monthName: 'May' }, { id: 6, monthName: 'June' }, { id: 7, monthName: 'July' }, { id: 8, monthName: 'August' }, { id: 9, monthName: 'September' }, { id: 10, monthName: 'October' }, { id: 11, monthName: 'November' }, { id: 12, monthName: 'December' }]

const yearArr = [{ id: new Date().getFullYear(), yearName: new Date().getFullYear() }, { id: new Date().getFullYear() + 1, yearName: new Date().getFullYear() + 1 }, { id: new Date().getFullYear() + 2, yearName: new Date().getFullYear() + 2 }, { id: new Date().getFullYear() + 3, yearName: new Date().getFullYear() + 3 }, { id: new Date().getFullYear() + 4, yearName: new Date().getFullYear() + 4 }, { id: new Date().getFullYear() + 5, yearName: new Date().getFullYear() + 5 }, { id: new Date().getFullYear() + 6, yearName: new Date().getFullYear() + 6 }, { id: new Date().getFullYear() + 7, yearName: new Date().getFullYear() + 7 }, { id: new Date().getFullYear() + 8, yearName: new Date().getFullYear() + 8 }, { id: new Date().getFullYear() + 9, yearName: new Date().getFullYear() + 9 }, { id: new Date().getFullYear() + 10, yearName: new Date().getFullYear() + 10 }]

const Holidays = () => {
  const navigate = useNavigate();
  const { permissionArr } = useSelector(state => state.UserGetReducer)
  const localPermission = permissionArr;
  useEffect(() => {
    if (!localPermission.includes(Permissions.ADMIN_HOLIDAYS)) {
      navigate('/');
    }
  }, [...localPermission])

  const initialState = { holidayId: null, holidayName: '', holidayDate: '', holidayRemarks: '' }
  const [isLoading, setIsloading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [userQuery, setUserQuery] = useState("");
  const [searchQuery, setSearchQuery] = useState('');


  const [editId, setEditId] = useState('')

  const [holiday, setHoliday] = useState(initialState)
  const [holidayList, setHolidayList] = useState([])

  // modal
  const [modal, setModal] = useState(false)

  const [monthId, setMonthId] = useState(new Date().getMonth() + 1);
  const [yearId, setYearId] = useState(new Date().getFullYear());

  const sendQuery = (query) => {
    setSearchQuery(query);
  };
  const delayedQuery = useCallback(
    lodash.debounce((q) => sendQuery(q), 1000),
    []
  );

  useEffect(() => {
    setIsloading(true);
    getHolidayListData();
  }, [searchQuery, monthId, yearId])

  const getHolidayListData = () => {
    let payload = {
      q: searchQuery,
      page: 1,
      pagesize: 100000,
      month: monthId,
      year: yearId
    }
    getHolidayList((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setHolidayList(data);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  }

  const handleAddHoliday = (e) => {
    setModal(!modal)
    setEditId('')
    setHoliday('')
  }

  const handleSearchChange = (e) => {
    let q = e.target.value;
    delayedQuery(q);
    setUserQuery(q);
  };

  const handleChangeHoliday = (e) => {
    const { name, value } = e.target;
    setHoliday({ ...holiday, [name]: value });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let payload = {
      holiday_name: holiday.holidayName || '',
      date: holiday.holidayDate || '',
      remarks: holiday.holidayRemarks || ''
    }

    let editPayload = {
      id: editId,
      holiday_name: holiday.holidayName || '',
      date: holiday.holidayDate || '',
      remarks: holiday.holidayRemarks || ''
    }
    if (!editId) {
      setIsloading(false);
      setIsModalLoading(true);
      addHoliday((res) => {
        const { success, message, error } = res;
        if (success === true) {
          setModal(!modal);
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          getHolidayListData();
        } else if (success === false || success === 'undefined') {
          getHolidayListData();
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, payload);
    }

    if (editId) {
      setIsloading(false);
      setIsModalLoading(true);
      updateHoliday((res) => {
        const { success, message, error } = res;
        if (success === true) {
          setModal(!modal);
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          getHolidayListData();
        } else if (success === false || success === 'undefined') {
          getHolidayListData();
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, editPayload);
    }
  }

  const handleEdit = (e, elem) => {
    e.preventDefault();
    setModal(!modal);
    setEditId(elem.id);
    setHoliday({ ...holiday, holidayId: elem.id, holidayName: elem.name, holidayDate: elem.date, holidayRemarks: elem.remarks })
  }

  const handleDelete = (id) => {
    let payload = {
      id: id
    }
    swal({
      title: 'Delete Holiday',
      text: 'Are you sure, you want to delete?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
    }).then((isConfirm) => {
      if (isConfirm) {
        setIsloading(true);
        deleteHoliday(
          (res) => {
            const { success, message, error } = res;
            if (success === true) {
              ModalService.openAlert('', message, 'success');
              setIsloading(false);
              getHolidayListData();
            } else if (success === false || success === 'undefined') {
              getHolidayListData();
              ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
            }
            setIsloading(false);
          }, payload);
      } else {
        setIsloading(false);
      }
    });
  };
  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='holidayList'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle dashBorardName='Holidays' className="lightTitle" />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <AddUserButton name='Add Holiday' onClick={handleAddHoliday} />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <div className='filterBlock d-flex flex-wrap align-items-center justify-content-between'>
                        <div className='filterWrapper d-flex flex-wrap align-items-center'>
                          <div className='filterInput'>
                            <FormGroup >
                              <Label>Month:</Label>
                              <SingleSelect
                                // disabled={editId}
                                id="month"
                                name="month"
                                value={monthId === null || monthId === 'undefined' ? '' : monthId}
                                onChange={(e) => {
                                  // setIsloading(true)
                                  setMonthId(e.target.value)
                                }}
                                options={monthArr}
                                label={'monthName'}
                                selectedValueKey={'id'}
                              />
                            </FormGroup>
                          </div>
                          <div className='filterInput'>
                            <FormGroup >
                              <Label>Year:</Label>
                              <SingleSelect
                                // disabled={editId}
                                id="year"
                                name="year"
                                value={yearId === null || yearId === 'undefined' ? '' : yearId}
                                onChange={(e) => {
                                  // setIsloading(true)
                                  setYearId(e.target.value)
                                }}
                                options={yearArr}
                                label={'yearName'}
                                selectedValueKey={'id'}
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className='searchArea'>
                          <div className='searchBlock'>
                            <SearchInput
                              parentStyle={{ maxWidth: '200px', minWidth: '230px', marginRight: 0 }}
                              InputProps={{
                                name: 'search',
                                placeholder: 'Search by name'
                              }}
                              onChange={handleSearchChange}
                              value={userQuery}
                            />
                          </div>

                        </div>
                      </div>
                    </Col>
                  </Row>
                  {holidayList && holidayList.length > 0 ? (
                    <Row>
                      <Col xs={12}>
                        <div className='table-responsive dealerTable'>
                          <Table className='mb-0'>
                            <thead>
                              <tr>
                                <th>Holiday Name</th>
                                <th>Date</th>
                                <th>Remarks</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {holidayList.map((elem, index) => {
                                const { id, name, date, remarks } = elem
                                return (
                                  <tr key={index}>
                                    <td>{name}</td>
                                    <td>{DateService.localDateOnly(date) || 'N/A'}</td>
                                    <td>
                                      {remarks ? (
                                        <>
                                          <div id={'Tooltip-' + index} className="holidayRemarkTooltip">{remarks.length > 50 ? `${remarks.substring(0, 50)}...` : remarks}</div>
                                          <UncontrolledTooltip
                                            modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
                                            // delay={{ show: 200, hide: 5 }}
                                            autohide={false}
                                            placement="bottom"
                                            target={'Tooltip-' + index}
                                          >
                                            {remarks}
                                          </UncontrolledTooltip>
                                        </>
                                      ) : 'N/A'}
                                    </td>
                                    <td>
                                      <div className='iconBlock justify-content-start'>
                                        <img src={editIcon} alt='editIcon' className='iconImg' onClick={(e) => handleEdit(e, elem)} />
                                        <img src={deleteIcon} alt='delete' className='iconImg' onClick={() => handleDelete(id)} />
                                      </div>
                                    </td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs={12}>
                        {messages.COMMON.NO_RECORD_MATCH}
                      </Col>
                    </Row>
                  )}

                </Container>
              </div>

              <Modal isOpen={modal} toggle={() => setModal(!modal)} centered className="HolidayModal" id="HolidayModal">
                {isModalLoading && <CustomSpinner />}
                <ModalBody className='p-0'>
                  <div className='ModalArea'>
                    <Container>
                      <Row>
                        <Col xs={12}>
                          <div className='modalHeading'>
                            <div className='title'>{editId ? 'Update' : 'Add'} Holiday</div>
                            <div className="closeButton"><img src={closeImg} alt="close" onClick={() => setModal(!modal)} /></div>
                          </div>
                        </Col>
                        <Col xs={12}>
                          <Form onSubmit={handleSubmit}>
                            <FormGroup>
                              <Label for="userName">Holiday Name <span className='required'>*</span></Label>
                              <UserInput
                                required={true}
                                type='text'
                                name='holidayName'
                                id='holidayName'
                                placeholder='Type Here'
                                value={holiday.holidayName === null || holiday.holidayName === 'undefined' ? '' : holiday.holidayName}
                                onChange={(e) => handleChangeHoliday(e, 'holidayName')}
                              />
                            </FormGroup>
                            <FormGroup>
                              <Label for="userName">Date <span className='required'>*</span></Label>
                              <UserInput
                                required={true}
                                type='date'
                                name='holidayDate'
                                id='holidayDate'
                                placeholder='Type Here'
                                value={holiday.holidayDate === null || holiday.holidayDate === 'undefined' ? '' : holiday.holidayDate}
                                onChange={(e) => handleChangeHoliday(e, 'holidayDate')}
                              />
                            </FormGroup>
                            <FormGroup>
                              <Label for="userName">Remarks</Label>
                              <UserTextArea
                                required={false}
                                name='holidayRemarks'
                                id='holidayRemarks'
                                className="holidayRemarks"
                                placeholder='Type Here'
                                value={holiday.holidayRemarks === null || holiday.holidayRemarks === 'undefined' ? '' : holiday.holidayRemarks}
                                onChange={(e) => handleChangeHoliday(e, 'holidayRemarks')}
                              />
                            </FormGroup>
                            <div className='text-center'>
                              <CommonButton name={editId ? 'Update' : 'Add'} btnClass={'btnPrimary'} type="submit" />
                            </div>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </ModalBody>
              </Modal>

            </div>
          </div>
        </div>
      </div>
    </>
  )
};

export default Holidays;
